<template>
  <div>
    <NodePageLanding v-if="node" v-bind="node" />
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'LandingPage',
})

definePageMeta({
  name: 'landing-page-de',
  drupalFrontendRoute: true,
  path: '/deutschland',
  languageMapping: {
    fr: '/allemagne',
    en: '/germany',
  },
  hideBreadcrumb: true,
})

// Handles redirects and metatags.
const { entity: node } = await useDrupalRouteQuery('slug')

await renderPageDependencies()
</script>
